// extracted by mini-css-extract-plugin
export default {"Rcontainer":"Reach_Rcontainer__4iGXv","subcontainer":"Reach_subcontainer__YepNR"};